import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, HostListener, Inject, Input, OnDestroy, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from 'ui-library';
import { CameraCaptureComponent } from '../camera-capture/camera-capture.component';

@Component({
  selector: 'app-file-input',
  imports: [FormsModule, CommonModule, ButtonComponent, TranslateModule, MatCardModule, MatIconModule, CameraCaptureComponent],
  templateUrl: './file-input.component.html',
  styleUrl: './file-input.component.scss'
})
export class FileInputComponent implements OnInit, OnDestroy {
  // Components API
  @Input() image: string | null = null;
  @Input() accept: string = '*/*';
  @Input() max: number = 1;
  @Input() width: number = 0;
  @Input() height: number = 0;
  @Input() noPreview: boolean = false;
  @Input() multiple: boolean = false;
  @Input() camera: boolean = false;
  @Output() change = new EventEmitter<FileList>();
  @Output() delete = new EventEmitter<any>();

  // Variables
  fileOver: boolean = false;
  files: FileList | null = null;
  cameraOpen: boolean = false;
  // Phone-sized: a coarse pointer covers real devices in either rotation, the
  // dimensions cover a narrow desktop window during development.
  private static readonly PHONE_QUERY = '(pointer: coarse), (max-width: 768px), (max-height: 500px)';
  isPhone: boolean = false;
  private phoneQuery?: MediaQueryList;
  private onPhoneQueryChange = (e: MediaQueryListEvent) => (this.isPhone = e.matches);

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) return;
    this.phoneQuery = window.matchMedia(FileInputComponent.PHONE_QUERY);
    this.isPhone = this.phoneQuery.matches;
    this.phoneQuery.addEventListener('change', this.onPhoneQueryChange);
  }

  ngOnDestroy() {
    this.phoneQuery?.removeEventListener('change', this.onPhoneQueryChange);
  }

  onCameraCapture(file: File) {
    const transfer = new DataTransfer();
    transfer.items.add(file);
    this.files = transfer.files;
    this.drawImage();
    this.change.emit(transfer.files);
  }

  // Listeners
  @HostListener('dragover', ['$event'])
  onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = true;
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
  }

  @HostListener('drop', ['$event'])
  onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    
    if (evt.dataTransfer?.files?.length) {
      this.onFilesDropped(evt.dataTransfer.files);
    }
  }


  drawImage() {
    if (this.files && !this.noPreview) {
      const files = Array.from(this.files);

      const images = files.filter(file => file.type.startsWith('image/'));
      if (images.length && this.max == 1) {
        const file = this.files[0];

        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (e: ProgressEvent<FileReader>) => {
            if (e.target && e.target.result) {
              const url = e.target.result;
              this.image = url.toString();
            }
          }

          reader.onerror = error => {
            console.error('error', error);
          }

          reader.onerror = error => {
            console.error('error', error);
          }
        } else {
          this.image = '/img/image-placeholder.jpg';
        }
      }
    }
  }

  onFilesDropped(files: FileList) {
    this.files = files;
    this.drawImage();
    this.change.emit(files);
  }

  onFileSelected(event: Event) {
    event.stopPropagation()
    const input = event.target as HTMLInputElement;
    this.files = input.files;

    if (this.files) {
      this.drawImage();
      this.change.emit(this.files);
    }
    console.log('this.files[0] :>> ', this.files && this.files[0]);
  }

  onDelete() {
    this.image = null;
    this.files = null;
    this.delete.emit();
  }
}
